<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Welcome to the SpethBot WebApp!</h1>
    <div>
      <h2 class="mb-4 font-bold text-2xl" data-toggle="tooltip" title="Commands that can be used with !command_name in TwitchChat." >
        Commands
        <span class="inline-block"><sup><icon name="tooltip" class="w-3 h-3 mr-2" /></sup></span>
        </h2>
      <p class="mb-8 leading-normal">
        I currently know {{ known_commands }} commands and {{ enabled_commands }} are enabled.
      </p>

    </div>
    <div>
      <h2 class="mb-4 font-bold text-2xl" data-toggle="tooltip" title="Quotes added during streams." >
          Quotes
          <span class="inline-block"><sup><icon name="tooltip" class="w-3 h-3 mr-2 " /></sup></span>
      </h2>
      <p class="mb-8 leading-normal">
        I currently have {{ known_quotes }} quotes available.
      </p>
    </div>
    <div>
      <h2 class="mb-4 font-bold text-2xl" data-toggle="tooltip" title="Quick reactions that trigger replies in chat." >
          Reactions
          <span class="inline-block"><sup><icon name="tooltip" class="w-3 h-3 mr-2 " /></sup></span>
      </h2>
      <p class="mb-8 leading-normal">
        I currently have {{ known_reactions }} reactions available.
      </p>
    </div>
    <div>
      <h2 class="mb-4 font-bold text-2xl" data-toggle="tooltip" title="These are the messages that will be posted in Twitch Chat every few minutes." >
          Announcements
          <span class="inline-block"><sup><icon name="tooltip" class="w-3 h-3 mr-2 " /></sup></span>
      </h2>
        <p class="mb-8 leading-normal">
          I currently know {{ known_announcements }} announcement messages and {{ enabled_announcements }} are enabled.
      </p>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import useHelper from '@/Shared/useHelper'

export default {
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
  components: {
    Icon,
  },
  data() {
    return {
      helperApi: null,
    }
  },
  created() {
    this.helperApi = useHelper()
    if (!this.helperApi.state.commands) this.helperApi.fetchCommands()
    if (!this.helperApi.state.announcements) this.helperApi.fetchAnnouncements()
    if (!this.helperApi.state.quotes) this.helperApi.fetchQuotes()
    if (!this.helperApi.state.reactions) this.helperApi.fetchReactions()
  },
  computed: {
    known_commands() {
      const cmds = (this.helperApi && this.helperApi.state.commands) || {}
      return Object.keys(cmds).length
    },
    enabled_commands() {
      const cmds = (this.helperApi && this.helperApi.state.commands) || {}
      let enabled = 0;
      for(var i in cmds)
        if (cmds[i]['is_enabled'] == "1") {
          enabled++;
        }
      return enabled;
    },
    known_announcements() {
      const anns = (this.helperApi && this.helperApi.state.announcements) || {}
      return Object.keys(anns).length
    },
    enabled_announcements() {
      const anns = (this.helperApi && this.helperApi.state.announcements) || {}
      let enabled = 0;
      for(var i in anns)
        if (anns[i]['is_enabled'] == "1") {
          enabled++;
        }
      return enabled;
    },
    known_quotes() {
      const q = (this.helperApi && this.helperApi.state.quotes) || {}
      return Object.keys(q).length
    },
    known_reactions() {
      const r = (this.helperApi && this.helperApi.state.reactions) || {}
      return Object.keys(r).length
    },
  },
}
</script>
